function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './SurpriseWizard.css';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import { deepEqual } from 'fast-equals';
import { useLocation } from 'react-router-dom';
import { canUseDOM, getDictionaryItem, replaceUrlPluses } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get } from '../../utils/getPropertyByPath';
import { SurpriseWizardSelect } from './components/SurpriseWizardSelect';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SurpriseWizardPOI } from './components/SurpriseWizardPOI';
import { qsToObject } from '../../utils/querystring';
import { splitter } from '../Listing';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { isNotNil } from '../../utils/IsNil';
import { checkJssError } from '../../utils/checkJssError';
import { replacerPlusAndAmpersandForValidQueryString } from '../../utils/replacerPlusAndAmpersandForValidQueryString';
const SurpriseWizardComponent = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const location = useLocation();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [isVdsite, setIsVdsite] = useState(true);
  const [tagSelectWithDescription, setTagSelectWithDescription] = useState([]);
  const [removedOldQueryString, setRemovedOldQueryString] = useState(false);
  const [isSomeSelectOpen, setIsSomeSelectOpen] = useState(false);
  const [queryString, setSetQueryString] = useState({});
  const baseObject = get(fields, "data.datasource");
  const subtitle = get(baseObject, "subtitle.jss.value");
  const mainText = get(baseObject, "mainText.jss.value");
  const travelerTypes = get(baseObject, "travelerTypes.targetItem");
  const travelerTypesName = get(baseObject, "travelerTypes.targetItem.title.jss.value");
  const activityInterests = get(baseObject, "activityInterests.targetItem");
  const activityInterestsName = get(baseObject, "activityInterests.targetItem.title.jss.value");
  const tripTypes = get(baseObject, "tripTypes.targetItem");
  const tripTypesName = get(baseObject, "tripTypes.targetItem.title.jss.value");
  const surpriseCTAHref = get(baseObject, "surpriseCTA.jss.value.href");
  const preselectedPOIS = get(baseObject, "preselectedPOIS.values");
  const algoliaIndexes = get(params, 'SearchIndex');
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const moduleDictionary = get(fields, 'data.moduleDictionary');
  const shuffleText = getDictionaryItem(moduleDictionary, 'Shuffle') || 'Shuffle';
  const surpriseCTAText = getDictionaryItem(moduleDictionary, 'SurpriseMe') || 'Surprise me';
  const selectNames = [travelerTypesName, activityInterestsName, tripTypesName];
  const isPreselectedValueExists = [travelerTypes, activityInterests, tripTypes].some(element => element && element.preselectedTags.values.length);
  const typesMap = () => {
    const types = ["travelerTypes", "activityInterests", "tripTypes"];
    return types.reduce((acc, type) => {
      return _objectSpread(_objectSpread({}, acc), {}, {
        [baseObject[type].targetItem.title.jss.value]: baseObject[type].targetItem.fieldNameItem.item.fieldName.value
      });
    }, {});
  };
  useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const regexWithParentheses = /\{.*?\}/g;
  const getDescriptionFromMainText = useMemo(() => mainText.replace(regexWithParentheses, '!,').split("!,").reduce((acc, value) => {
    if (value.length === 0) {
      return acc;
    }
    acc.push(value.trim());
    return acc;
  }, []), []);
  const getSelectNamesFromMainText = useMemo(() => mainText.match(regexWithParentheses).map(match => match.replace(/^\{|\}$/g, '')), []);
  const selectMap = {
    trip_type: tripTypes,
    activity_interests: activityInterests,
    traveller_type: travelerTypes,
    traveler_type: travelerTypes
  };
  const matchSelectTypes = useCallback(selectNames => selectNames.map(selectName => selectMap[selectName]), []);
  useEffect(() => {
    const selectNames = mainText ? getSelectNamesFromMainText : [];
    const description = mainText ? getDescriptionFromMainText : [];
    const selectTypes = selectNames.length ? matchSelectTypes(selectNames) : [travelerTypes, activityInterests, tripTypes];
    // lastTextElement is needed if we have text after last {select} in "mainText"
    const selectTypesWithLastText = description.length > 3 ? [...selectTypes, "lastTextElement"] : selectTypes;
    const selectsDataWithDescription = selectTypesWithLastText.map((selectData, index) => {
      let eventsAnalyticsData = null;
      if (index === 0) {
        eventsAnalyticsData = eventsAnalytics["TrevelingAsClickAnalytics"];
      }
      if (index === 1) {
        eventsAnalyticsData = eventsAnalytics["InterestedInClickAnalytics"];
      }
      if (index === 2) {
        eventsAnalyticsData = eventsAnalytics["LookingForClickAnalytics"];
      }
      if (index === 3) {
        return {
          eventsAnalyticsData: null,
          selectData: null,
          description: description[index]
        };
      }
      return {
        eventsAnalyticsData,
        selectData,
        description: description[index]
      };
    });
    setTagSelectWithDescription(selectsDataWithDescription);
  }, []);
  const createQueryParams = () => {
    const queryParams = canUseDOM ? qsToObject(location.search) : {};
    if (Object.keys(queryParams).length !== 0) {
      for (let key in queryParams) {
        const newKeys = key.split('+').join(' ');
        queryParams[newKeys] = queryParams[key].split(splitter).join(', ');
        queryParams[newKeys] = replaceUrlPluses(queryParams[newKeys]) || queryParams[newKeys];
        if (key !== newKeys) {
          delete queryParams[key];
        }
      }
    }
    return queryParams;
  };
  const queryParams = createQueryParams();
  useEffect(() => {
    if (!deepEqual(queryString, queryParams)) {
      setSetQueryString(queryParams);
    }
  }, [queryParams]);
  const isSurpriseButtonEnabled = useCallback(() => isNotNil(queryString) ? Object.keys(queryString).every(key => queryParams[key].length) : false, [queryString]);
  const queryStringForSurpriseCta = () => {
    let str = "?";
    const fieldTypeToFieldValueMap = {};
    if (Object.keys(queryParams).length !== 0) {
      for (const [key, value] of Object.entries(typesMap())) {
        if (queryParams[key]) {
          if (fieldTypeToFieldValueMap[value]) {
            fieldTypeToFieldValueMap[value] = fieldTypeToFieldValueMap[value].concat(splitter, replacerPlusAndAmpersandForValidQueryString(queryParams[key]));
          } else {
            fieldTypeToFieldValueMap[value] = replacerPlusAndAmpersandForValidQueryString(queryParams[key]);
          }
        }
      }
      for (const [key, value] of Object.entries(fieldTypeToFieldValueMap)) {
        str += `${key}=${value}&`;
      }
      return str.slice(0, -1);
    }
    return str;
  };
  const blurForTitle = () => canUseDOM && window.matchMedia("(max-width: 1024px)").matches && isSomeSelectOpen ? "blur" : "";
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields || !fields.data || !baseObject || !baseObject.mainText || !baseObject.travelerTypes || !baseObject.travelerTypes.targetItem || !baseObject.activityInterests || !baseObject.activityInterests.targetItem || !baseObject.tripTypes || !baseObject.tripTypes.targetItem) {
    console.info('SurpriseWizard component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [SurpriseWizard component is empty: please provide data source]");
    }
    return null;
  }
  const analyticsHandle = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SurpriseMeButtonClickAnalytics'], params), surpriseCTAText);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "surpriseWizardWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tagDropdownsWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('tagDropdownsTitle', blurForTitle())
  }, subtitle.toUpperCase()), /*#__PURE__*/React.createElement("div", {
    className: clsx('tagDropdowns', {
      'blur': isSomeSelectOpen
    })
  }, tagSelectWithDescription.map((_ref2, index) => {
    let {
      selectData,
      description,
      eventsAnalyticsData
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: "tagDropdown",
      key: index
    }, /*#__PURE__*/React.createElement("span", {
      className: "tagDropdownDescription"
    }, description), selectData && /*#__PURE__*/React.createElement(SurpriseWizardSelect, {
      selectData: selectData,
      setIsSomeSelectOpen: setIsSomeSelectOpen,
      setRemovedOldQueryString: setRemovedOldQueryString,
      eventsAnalyticsData: eventsAnalyticsData,
      params: params
    }));
  })), /*#__PURE__*/React.createElement("span", {
    className: clsx('surpriseCTAWrapper', {
      'disabled': !isSurpriseButtonEnabled()
    })
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": surpriseCTAText,
    href: `${surpriseCTAHref}${queryStringForSurpriseCta()}`,
    className: clsx('surpriseCTAButton', isSurpriseButtonEnabled() ? 'enabled' : 'disabled', {
      'blur': isSomeSelectOpen
    }),
    onClick: analyticsHandle
  }, surpriseCTAText))), /*#__PURE__*/React.createElement("div", {
    className: "POIWrapper"
  }, /*#__PURE__*/React.createElement(SurpriseWizardPOI, {
    preselectedPOIS: preselectedPOIS,
    algoliaIndexes: algoliaIndexes,
    shuffleText: shuffleText,
    selectNames: selectNames,
    queryParams: queryString,
    removedOldQueryString: removedOldQueryString,
    isPreselectedValueExists: isPreselectedValueExists,
    eventsAnalytics: eventsAnalytics,
    params: params
  }))));
};
const SurpriseWizard = props => checkJssError(props, SurpriseWizardComponent);
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c1btmun6";
const rtlStyles = "r11l924t";
const ltrStyles = "l1i3mbnk";
export default SurpriseWizard;